import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../_services/global.service';
import { CategoryResponse } from '../../../_models/category';
import {
  ResponseStructure,
  requiredFileType,
} from '@iq-central-front-end/share';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '../../../_services/auth.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import {
  trigger,
  transition,
  group,
  query,
  style,
  animate,
} from '@angular/animations';
import Swal from 'sweetalert2';
import { CourseResponseDTO, TopicResponseDTO } from '../../../_models/course';

@Component({
  selector: 'iq-central-front-end-create-course',
  templateUrl: './edit-course.component.html',
  styleUrls: ['./edit-course.component.scss'],
})
export class EditCourseComponent implements OnInit, OnDestroy {
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [['bold']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };

  sub: Subscription = new Subscription();
  selected = '';
  updateCourseForm: FormGroup;
  categories: CategoryResponse[] = [];
  subCategories: any[] = [];
  topics: TopicResponseDTO[] = [];
  selectedTopics: any[] = [];
  course: any;
  userType: any;
  isLoading: boolean;
  time = { hour: 12, minute: 30 };
  lesson: any[] = [];
  courseCode: string;
  courseData: CourseResponseDTO;
  fileName: string;
  topicsObjectArray: any[] = [];
  courseDuration: any;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private _course: CourseService,
    private _global: GlobalService,
    private _auth: AuthService,
    private route: ActivatedRoute,
    private _jwt: JwtHelperService
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe((res) => {
      this.courseData = res['resolvedData'].responseResult;
      console.log(this.courseData);
      this.topics = this.courseData['topics'];
      this.topics.forEach((t) => {
        this.selectedTopics.push(t.id);
      });

      this.getFileName(this.courseData.imageUrl);
      this.parseToDate(this.courseData.duration);
    });
    this.courseCode = this.route.snapshot.paramMap.get('code');
    this.initCourseForm();
    this.getAllCategories();
    this.decodeToken();
  }

  initCourseForm() {
    this.updateCourseForm = this.fb.group({
      certificate: [null, [Validators.required, requiredFileType('pdf')]],
      picture: [null, [Validators.required]],
      id: [this.courseData?.category?.id ?? null],
      category: [this.courseData?.subCategory?.id ?? null],
      topics: [this.selectedTopics],
      description: [this.courseData.description, Validators.required],
      duration: [this.courseDuration, Validators.required],
      hasCertificate: [this.courseData.hasCertificate],
      level: [this.courseData.level, Validators.required],
      title: [this.courseData.title, Validators.required],
      courseType: [this.courseData.courseType, Validators.required],
      coursePrice: [this.courseData.coursePrice, Validators.required],
      courseCode: [this.courseData.code, Validators.required],
      certificateType: [this.courseData.certificateType],
    });
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  getAllCategories() {
    this._global.showSpinner();
    this.sub.add(
      this._course.getAllCategories().subscribe({
        next: (res) => {
          this.categories = res['responseResult'];
          this.topics = [];
          this._global.hideSpinner();
        },
      })
    );
  }

  getAllSubCategories(event: CategoryResponse) {
    console.log(event);
    this._global.showSpinner();
    this.sub.add(
      this._course.getAllSubcategories(event.id).subscribe({
        next: (res) => {
          this.subCategories = res['responseResult'];
          this._global.hideSpinner();
        },
      })
    );
  }

  getAllTopics(event) {
    this._global.showSpinner();
    this.sub.add(
      this._course.getllTopics(event).subscribe({
        next: (res) => {
          this.topics = res['responseResult'];
          this._global.hideSpinner();
        },
      })
    );
  }

  finish() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This course will be updated and you will be taken to your overview page',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1CB4AE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.value) {
        this._global.showSpinner();
        this.updateCourse();
      }
    });
  }

  updateCourse(page?) {
    console.log(this.updateCourseForm.value);
    this.isLoading = true;
    if (!this.updateCourseForm.dirty) {
      if (page) {
        this.isLoading = false;
        this.router.navigate(['courses/edit-lesson', this.courseCode]);
      } else {
        this._global.hideSpinner();
        this.router.navigate(['courses/course-details', this.courseCode]);
      }
    } else {
      this.topicsObject();
      let price = this.updateCourseForm.get('coursePrice').value;
      // let newPrice = parseInt(price);
      // this.updateCourseForm.patchValue({ coursePrice: newPrice });
      this.updateCourseForm.patchValue({
        duration: `${this.updateCourseForm.get('duration').value.hour}:${
          this.updateCourseForm.get('duration').value.minute
        }`,
      });
      this.updateCourseForm.patchValue({ topics: this.topicsObjectArray });
      const payload = this.updateCourseForm.value;

      const courseJson = JSON.stringify(payload);
      const certificate = this.updateCourseForm.get('certificate').value;
      const picture = this.updateCourseForm.get('picture').value;
      this.sub.add(
        this._course
          .updateCourse(certificate, this.courseCode, courseJson, picture)
          .subscribe({
            next: (res: ResponseStructure) => {
              this.course = res.responseResult;
              if (page) {
                this.isLoading = false;
                this.router.navigate([
                  'courses/edit-lesson',
                  this.course['code'],
                ]);
              } else {
                this._global.hideSpinner();
                this.router.navigate([
                  'courses/course-details',
                  this.courseCode,
                ]);
              }
            },
            error: (e) => {
              this.isLoading = false;
            },
          })
      );
    }
  }

  addLesson(param: string) {
    this.updateCourse(param);
  }

  // onTimeChange(value: { hour: string; minute: string }) {
  //   this.newTime = `${value.hour}:${value.minute}`;
  // }

  parseToDate(duration: string) {
    const strArr = duration.split(':');
    this.courseDuration = {
      hour: parseInt(strArr[0]),
      minute: parseInt(strArr[1]),
      second: 0,
    };
  }

  getFileName(imageUrl) {
    let fileNameLowerCase = imageUrl.split('/').pop().toLowerCase();
    this.fileName = fileNameLowerCase;
  }

  decodeToken() {
    const token = localStorage.getItem('token');
    const decodedToken = this._jwt.decodeToken(token);
    this.userType = decodedToken['user_type'];
  }

  topicsObject() {
    const formTopic: any[] = this.updateCourseForm.get('topics').value;
    this.topics.forEach((topic) => {
      formTopic.includes(topic.id), this.topicsObjectArray.push(topic);
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
